module.exports = __webpack_public_path__ + "img/Tier 1 Alternative 2.f164640e.jpg";